import {TableTheme, TableWidgetData} from '@dv5/domain'
import {CSSProperties, FC} from 'react'
import {TableThemePicker} from './TableThemePicker'
import {useTableWidgetUpdate} from './useTableWidgetUpdate'
import './TableWidgetToolbar.less'

interface Props {
    canvasId: string
    widgetId: string
    data: TableWidgetData
    toolbarStyles: CSSProperties
    onExpandToFull: () => void
}

export const TableWidgetToolbar: FC<Props> = ({
    canvasId,
    widgetId,
    data,
    toolbarStyles,
    onExpandToFull,
}) => {
    const {updateData} = useTableWidgetUpdate({canvasId, widgetId})

    const handleThemeChange = (theme: TableTheme) => {
        updateData(['theme'], {...data, theme})
    }

    return (
        <div className='table-widget-toolbar' style={toolbarStyles}>
            <TableThemePicker
                prefix="table-widget-toolbar"
                value={data.theme}
                onChange={handleThemeChange}
            />
            <div className='table-widget-toolbar__divider' />
            <button
                className='table-widget-toolbar__button table-widget-toolbar__button--expand'
                onClick={onExpandToFull}
                aria-label='Expand to full editor'
                type='button'
            >
                ↗
            </button>
        </div>
    )
}
